const PublicRoute = ({children}) => children;

export default PublicRoute;
